import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const ThinkleticsPointsDetails = () => {
    const { id } = useParams();
    const [point, setPoint] = useState(null);

    useEffect(() => {
        const fetchPoint = async () => {
            try {
                const response = await axios.get(`/api/thinkleticspoints/${id}`);
                setPoint(response.data);
            } catch (error) {
                console.error('Error fetching point details', error);
            }
        };

        fetchPoint();
    }, [id]);

    if (!point) return <div>Loading...</div>;

    return (
        <div>
            <h1>{point.eventTitle}</h1>
            <p>Event Code: {point.eventCode}</p>
            <p>Event Step: {point.eventStep}</p>
            <p>Event Action: {point.eventAction}</p>
            <p>Event Action Short Code: {point.eventActionShortCode}</p>
            <p>Event Action Points: {point.eventActionPoints}</p>
            <p>Event Action Points Rule: {point.eventActionPointsRule}</p>
            <p>Event Action Points Validation: {point.eventActionPointsValidation}</p>
            <p>Is Active: {point.isActive ? 'Yes' : 'No'}</p>
            <p>Is Deleted: {point.isDeleted ? 'Yes' : 'No'}</p>
            <p>Date Created: {new Date(point.dateCreated).toLocaleDateString()}</p>
            {/* Add more fields as needed */}
        </div>
    );
};

export default ThinkleticsPointsDetails;
